<div class="collaboration-dataset-wrapper" [class.p15]="isAddRemoveDataset">
  <h3 nz-typography class="nfl-form-label">{{ isAddRemoveDataset ? 'Edit ' : '' }}Associate Dataset(s)</h3>

  <div class="dataset-selection">
    <!-- Search Input -->
    <div class="search-container">
      <nz-input-group nzSearch [nzSuffix]="suffixIconSearch">
        <input type="text" nz-input placeholder="Search" [(ngModel)]="searchValue" (input)="onSearch()" />
      </nz-input-group>
      <ng-template #suffixIconSearch>
        <span nz-icon nzType="search"></span>
      </ng-template>
    </div>

    <!-- Dataset Table -->
    <nz-table
      #datasetTable
      [nzData]="filteredDatasets"
      [nzLoading]="isLoading"
      [nzFrontPagination]="false"
      [nzShowPagination]="false"
      [nzScroll]="{ y: '25rem' }"
      class="dataset-table"
    >
      <thead>
        <tr>
          <th nzWidth="60px">
            <label
              nz-checkbox
              [(ngModel)]="allChecked"
              (ngModelChange)="updateAllChecked()"
              [nzIndeterminate]="indeterminate"
            >
            </label>
          </th>
          <th nzWidth="25%">Connection Name</th>
          <th nzWidth="25%">Table Name</th>
          <th nzWidth="25%">Schema Name</th>
          <th
            nzWidth="25%"
            [nzFilterFn]="statusFilterFn"
            [nzFilters]="statusFilter"
            nzSortOrder="ascend"
            [nzSortFn]="statusSortFn"
          >
            Status
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let dataset of datasetTable.data; trackBy: trackByDataset"
          [class.disabled-row]="dataset.status !== 'ACTIVE'"
        >
          <td>
            <label
              nz-checkbox
              [ngModel]="dataset.isSelected"
              [nzDisabled]="dataset.status !== 'ACTIVE'"
              nz-tooltip
              [nzTooltipTitle]="dataset.status !== 'ACTIVE' ? 'Table status is pending' : ''"
              (ngModelChange)="onDatasetSelect(dataset, $event)"
            >
            </label>
          </td>
          <td>{{ dataset.dataConnectionName }}</td>
          <td>{{ dataset.tableName }}</td>
          <td>{{ dataset.schemaName }}</td>
          <td>
            <nz-tag [nzColor]="getStatusColor(dataset.status)">
              {{ getDisplayStatus(dataset.status) }}
            </nz-tag>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
  <div class="button-container" *ngIf="isAddRemoveDataset">
    <button nz-button nzType="default" (click)="onCancel()">Cancel</button>
    <button nz-button nzType="primary" (click)="addRemoveDataset()" [nzLoading]="isLoading">Save</button>
  </div>
</div>
